/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors } from '@chegg-ui/theme';
import { Typography } from '@chegg-ui/typography';
import styled from 'styled-components';
export var SelectionMenuContainer = styled.div.withConfig({
  componentId: "sc-1cp9eym-0"
})(["> div + div{margin-left:", ";margin-top:", ";}", " flex-direction:", ";border-radius:", ";background-color:", ";"], function (_ref) {
  var menuDirection = _ref.menuDirection,
      customTheme = _ref.customTheme;
  return customTheme.showBorderItem ? menuDirection === 'horizontal' ? '-2px' : 0 : 0;
}, function (_ref2) {
  var menuDirection = _ref2.menuDirection,
      customTheme = _ref2.customTheme;
  return customTheme.showBorderItem ? menuDirection === 'horizontal' ? 0 : '-2px' : 0;
}, function (_ref3) {
  var fullWidth = _ref3.fullWidth;
  return fullWidth ? "display: flex; width: 100%;" : "display: inline-flex;";
}, function (_ref4) {
  var menuDirection = _ref4.menuDirection;
  return menuDirection === 'horizontal' ? 'row' : 'column';
}, function (_ref5) {
  var customTheme = _ref5.customTheme;
  return customTheme.borderRadius;
}, function (_ref6) {
  var customTheme = _ref6.customTheme;
  return customTheme.defaultBackgroundColor;
});

var setBorderRadius = function setBorderRadius(_ref7) {
  var customTheme = _ref7.customTheme,
      lastIndex = _ref7.lastIndex,
      firstIndex = _ref7.firstIndex,
      menuDirection = _ref7.menuDirection;

  if (customTheme.showBorderItem) {
    return '';
  } else {
    if (menuDirection === 'horizontal') {
      return firstIndex ? '8px 0 0 8px' : lastIndex ? '0 8px 8px 0' : '';
    } else {
      return firstIndex ? '8px 8px 0 0' : lastIndex ? '0 0 8px 8px' : '';
    }
  }
};

export var SelectionMenuItem = styled.div.withConfig({
  componentId: "sc-1cp9eym-1"
})(["position:relative;display:flex;flex-grow:1;align-items:center;height:3rem;color:", ";padding:", ";font-family:", ";font-weight:", ";cursor:pointer;&:hover{color:", ";}&:after{content:'';position:absolute;top:0;left:0;height:100%;width:100%;border:", ";", ";", ";z-index:", ";box-sizing:border-box;border-radius:", ";background:", ";}&:hover:after{border-color:", ";z-index:3;background:", ";}> svg{", " display:flex;margin:0 auto;z-index:", ";color:", ";}> span{> svg{", "}display:flex;margin:0 auto;align-items:center;z-index:", ";color:", ";}"], function (_ref8) {
  var customTheme = _ref8.customTheme;
  return customTheme.defaultFontColor;
}, function (_ref9) {
  var customTheme = _ref9.customTheme;
  return customTheme.padding;
}, font.family.aspira, font.weight.medium, function (_ref10) {
  var isChecked = _ref10['aria-checked'],
      customTheme = _ref10.customTheme;
  return isChecked ? customTheme.activeFontColor : customTheme.hoverFontColor;
}, function (_ref11) {
  var isChecked = _ref11['aria-checked'],
      customTheme = _ref11.customTheme;
  return customTheme.showBorderItem ? isChecked ? "2px solid ".concat(colors.cheggOrange) : "2px solid ".concat(colors.greyLight) : "none";
}, function (_ref12) {
  var customTheme = _ref12.customTheme,
      menuDirection = _ref12.menuDirection;
  return !customTheme.showBorderItem ? menuDirection === 'horizontal' ? "border-top: 1px solid ".concat(colors.grey600, "; border-bottom: 1px solid ").concat(colors.grey600, ";border-left: 1px solid ").concat(colors.grey600, "; ") : "border-left: 1px solid ".concat(colors.grey600, "; border-right: 1px solid ").concat(colors.grey600, "; border-top: 1px solid ").concat(colors.grey600) : '';
}, function (_ref13) {
  var customTheme = _ref13.customTheme,
      lastIndex = _ref13.lastIndex,
      menuDirection = _ref13.menuDirection;
  return !customTheme.showBorderItem && lastIndex ? menuDirection === 'horizontal' ? "border-right: 1px solid ".concat(colors.grey600, ";") : "border-bottom: 1px solid ".concat(colors.grey600) : '';
}, function (_ref14) {
  var isChecked = _ref14['aria-checked'];
  return isChecked ? 2 : 1;
}, function (_ref15) {
  var customTheme = _ref15.customTheme,
      lastIndex = _ref15.lastIndex,
      firstIndex = _ref15.firstIndex,
      menuDirection = _ref15.menuDirection;
  return setBorderRadius({
    customTheme: customTheme,
    lastIndex: lastIndex,
    firstIndex: firstIndex,
    menuDirection: menuDirection
  });
}, function (_ref16) {
  var isChecked = _ref16['aria-checked'],
      customTheme = _ref16.customTheme;
  return customTheme.showBorderItem ? 'none' : isChecked ? customTheme.activeBackgroundColor : customTheme.defaultBackgroundColor;
}, function (_ref17) {
  var isChecked = _ref17['aria-checked'],
      customTheme = _ref17.customTheme;
  return customTheme.showBorderItem ? isChecked ? colors.cheggOrange : colors.greyMedium : '';
}, function (_ref18) {
  var isChecked = _ref18['aria-checked'],
      customTheme = _ref18.customTheme;
  return customTheme.showBorderItem ? 'none' : isChecked ? customTheme.activeBackgroundColor : customTheme.hoverBackgroundColor;
}, function (_ref19) {
  var customTheme = _ref19.customTheme;
  return customTheme.showBorderItem ? "margin-right: ".concat(10 / 16, "rem;") : '';
}, function (_ref20) {
  var customTheme = _ref20.customTheme;
  return customTheme.zIndex;
}, function (_ref21) {
  var isChecked = _ref21['aria-checked'],
      customTheme = _ref21.customTheme;
  return isChecked && customTheme.activeFontColor;
}, function (_ref22) {
  var customTheme = _ref22.customTheme;
  return customTheme.showBorderItem ? "margin-right: ".concat(10 / 16, "rem;") : '';
}, function (_ref23) {
  var customTheme = _ref23.customTheme;
  return customTheme.zIndex;
}, function (_ref24) {
  var isChecked = _ref24['aria-checked'],
      customTheme = _ref24.customTheme;
  return isChecked && customTheme.activeFontColor;
});
export var IconText = styled(Typography).withConfig({
  componentId: "sc-1cp9eym-2"
})(["margin-left:0.5rem;"]);
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        borderRadius: theme.radius.md,
        showBorderItem: false,
        defaultBackgroundColor: theme.colors.primary.light,
        hoverBackgroundColor: theme.colors.border.light100,
        activeBackgroundColor: colors.violet600,
        zIndex: theme.zIndex.xl9,
        iconColor: theme.colors.primary.dark,
        padding: "0 ".concat(theme.spacing.md),
        defaultFontColor: theme.colors.border.dark800,
        hoverFontColor: theme.colors.border.dark900,
        activeFontColor: theme.colors.primary.light
      };
    },
    fanta: {
      showBorderItem: true,
      defaultBackgroundColor: 'none',
      hoverBackgroundColor: 'none',
      activeBackgroundColor: 'none',
      zIndex: 'initial',
      iconColor: 'initial',
      padding: "0 ".concat(20 / 16, "rem"),
      defaultFontColor: colors.dark,
      hoverFontColor: 'initial',
      activeFontColor: 'initial'
    },
    prop: themeProp
  };
};